const TABLE_BORDER_TITLE_TYPES = new Set(['TABLE', 'EDITABLE', 'TREETABLE', 'GROUPTABLE'])

/**
 * Swing Table / EdiTable / TreeTable / GroupTable put `description` on JJTitledBorder.
 * `hideBorder=true` makes prepareTitleBorder() return null, so the title is not shown.
 */
export function shouldShowElementDescriptionLabel(options: {
  hideLabel?: boolean
  elementType?: string | null
  hideBorder?: boolean
}): boolean {
  if (options.hideLabel) return false
  const type = String(options.elementType ?? '').trim().toUpperCase()
  if (type === 'LABEL') return false
  if (TABLE_BORDER_TITLE_TYPES.has(type) && options.hideBorder) return false
  return true
}
